import { z } from 'zod';
import type { ToolSecret } from '../tools/common';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import {
  toolsExecuteResponseSchema,
  toolsUpdateToolsConnectionResponseSchema,
} from './common-responses';

const toolConnectionTypeSchema = z.enum([
  'apiKey',
  'oauth',
  'password',
  'noAuth',
]);

const toolSecretSchema = z.custom<ToolSecret>();

const toolConnectionDataSchema = z.object({
  type: toolConnectionTypeSchema,
  provider: z.string(),
  displayName: z.string(),
  secret: toolSecretSchema,
});

export const toolsUpdateToolsConnectionBodyV20260601Schema = z.object({
  mode: z.enum(['single', 'all']),
  toolId: z.string().optional(),
  connectionId: z.string(),
  connectionData: toolConnectionDataSchema,
});

export type ToolsUpdateToolsConnectionBody = z.infer<
  typeof toolsUpdateToolsConnectionBodyV20260601Schema
>;

export const toolsExecuteBodyV20260601Schema = z.object({
  toolName: z.string(),
  params: z.unknown(),
  conversationId: z.string().optional(),
  toolCallId: z.string(),
});

export type ToolsExecuteBody = z.infer<typeof toolsExecuteBodyV20260601Schema>;

export class ToolsUpdateToolsConnectionV20260601Schema
  implements ApiSchemaDefinition
{
  static readonly version = 'tools-update-tools-connection-2026-06-01' as const;

  readonly name = ToolsUpdateToolsConnectionV20260601Schema.version;
  readonly schema = toolsUpdateToolsConnectionBodyV20260601Schema;
  readonly response = toolsUpdateToolsConnectionResponseSchema;
}

export class ToolsExecuteV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'tools-execute-2026-06-01' as const;

  readonly name = ToolsExecuteV20260601Schema.version;
  readonly schema = toolsExecuteBodyV20260601Schema;
  readonly response = toolsExecuteResponseSchema;
}

export const TOOLS_API_SCHEMAS = [
  ToolsUpdateToolsConnectionV20260601Schema,
  ToolsExecuteV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
